module.exports = __webpack_public_path__ + "static/media/GameOfThronesThumb.9d000fdb.jpg";